/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Partner BFF
 * OpenAPI spec version: 1.0.0
 */
import {
  faker
} from '@faker-js/faker';

import type {
  HealthStatus
} from '../schemas';


export const getGetHealthResponseMock = (overrideResponse: Partial<Extract<HealthStatus, object>> = {}): HealthStatus => ({status: faker.string.alpha({length: {min: 10, max: 20}}), ...overrideResponse})

